var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66667 0H13.3333C14.8061 0 16 1.19391 16 2.66667V13.3333C16 14.8061 14.8061 16 13.3333 16H2.66667C1.19391 16 0 14.8061 0 13.3333V2.66667C0 1.19391 1.19391 0 2.66667 0ZM4.50987 6.75856C4.67255 6.82844 4.81967 6.93001 4.94267 7.05736L6.66667 8.78136L11.0573 4.39069C11.1803 4.26335 11.3275 4.16177 11.4901 4.09189C11.6528 4.02201 11.8278 3.98523 12.0048 3.98369C12.1818 3.98215 12.3574 4.01589 12.5213 4.08293C12.6851 4.14997 12.834 4.24898 12.9592 4.37417C13.0844 4.49936 13.1834 4.64823 13.2504 4.81209C13.3175 4.97595 13.3512 5.15152 13.3497 5.32856C13.3481 5.5056 13.3113 5.68056 13.2415 5.84323C13.1716 6.00591 13.07 6.15303 12.9427 6.27603L7.60933 11.6094C7.3593 11.8593 7.02022 11.9997 6.66667 11.9997C6.31312 11.9997 5.97404 11.8593 5.724 11.6094L3.05733 8.94269C2.92999 8.8197 2.82841 8.67257 2.75853 8.5099C2.68865 8.34723 2.65187 8.17227 2.65033 7.99523C2.6488 7.81819 2.68253 7.64262 2.74957 7.47876C2.81661 7.31489 2.91562 7.16602 3.04081 7.04083C3.166 6.91564 3.31487 6.81664 3.47873 6.7496C3.64259 6.68256 3.81816 6.64882 3.9952 6.65036C4.17224 6.6519 4.3472 6.68868 4.50987 6.75856Z",
    fill: "#278B9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxBig);
export default __webpack_public_path__ + "static/media/checkboxBig.6bf2de00378b358225832020de356971.svg";
export { ForwardRef as ReactComponent };